import React from "react";
import data from "../../../package.json";
// import { browserName, isMobile, mobileModel, mobileVendor } from "react-device-detect";

export const Version = () => {
	// const { innerWidth, innerHeight } = window;
	return (
		<div className="fixed z-50 flex flex-col top-0 left-0 text-[10px] text-white">
			<span>{data.version}</span>
			{/* <span>
				{innerWidth} x {innerHeight}
			</span> */}
			{/* 
			<span>{browserName}</span>
			{isMobile && (
				<>
					<span>{mobileVendor}</span>
					<span>{mobileModel}</span>
				</>
			)} */}
		</div>
	);
};
